import { SvgProps } from "../../../types";

const AnalyticsSvg = (props: SvgProps) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M4.44444 15.5556H6.66667V10H4.44444V15.5556ZM13.3333 15.5556H15.5556V4.44444H13.3333V15.5556ZM8.88889 15.5556H11.1111V12.2222H8.88889V15.5556ZM8.88889 10H11.1111V7.77778H8.88889V10ZM2.22222 20C1.61111 20 1.08796 19.7824 0.652778 19.3472C0.217593 18.912 0 18.3889 0 17.7778V2.22222C0 1.61111 0.217593 1.08796 0.652778 0.652778C1.08796 0.217593 1.61111 0 2.22222 0H17.7778C18.3889 0 18.912 0.217593 19.3472 0.652778C19.7824 1.08796 20 1.61111 20 2.22222V17.7778C20 18.3889 19.7824 18.912 19.3472 19.3472C18.912 19.7824 18.3889 20 17.7778 20H2.22222ZM2.22222 17.7778H17.7778V2.22222H2.22222V17.7778Z"
      fill={props.fill ?? "#1F1F1F"}
    />
  </svg>
);

export default AnalyticsSvg;
